import Div from "@jumbo/shared/Div/Div";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import ModifyMatterDetails from "./ModifyMatterDetails";


const ModifyMatterModal = ({open, handleClose, selectedRows}) => {
    const selectedIds = [];
    for (const row of selectedRows) {
        selectedIds.push(row.id);
    }

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Div
                sx={{
                    justifyContent: "flex-start !important"
                }}
                className="customize-modal preview-form"
            >
                <div className="modal-head">
                    <h2>&nbsp;</h2>
                    <IconButton className="close-modal-btn p-0" onClick={handleClose}>
                        <HighlightOffIcon/>
                    </IconButton>
                </div>
                <div className="modal-body-content">
                    <ModifyMatterDetails handleClose={handleClose} selectedId={selectedIds[0]}/>
                </div>
            </Div>
        </Modal>
    );
};


export default ModifyMatterModal;